import { render } from "./InfoTooltip.vue?vue&type=template&id=62fb4d7c"
import script from "./InfoTooltip.vue?vue&type=script&lang=js"
export * from "./InfoTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__